export default {
    namespaced: true,
    state: {
        list: [
            {id: 1, name: "Low"},
            {id: 2, name: "Medium"},
            {id: 3, name: "Height"}
        ]
    },
    getters: {
        list: state => state.list
    }
}